import { createContext } from "react";

const ClassLevelContext = createContext();

export default ClassLevelContext;
